import { useEffect } from "react";
import Lenis from "lenis";
import { nav } from "@/lib/site";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import Collections from "@/components/Collections";
import Featured from "@/components/Featured";
import Occasions from "@/components/Occasions";
import WhyUs from "@/components/WhyUs";
import HowToOrder from "@/components/HowToOrder";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import Footer from "@/components/Footer";

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        nav.lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            nav.lenis = null;
        };
    }, []);

    return (
        <div className="grain bg-[#F0EEE8] text-[#472500] min-h-screen" data-testid="app-root">
            <Navbar />
            <main>
                <Hero />
                <EditorialMarquee />
                <Collections />
                <Featured />
                <Occasions />
                <WhyUs />
                <HowToOrder />
                <Gallery />
                <Testimonials />
            </main>
            <Footer />
        </div>
    );
}

export default App;
